import { UserEntityPermissions } from './user-entity-permissions';

export enum UserRoles {
    Admin = 'Admin',
    Commercial = 'Commercial',
    DioceseManager = 'DioceseManager',
    VicarageManager = 'VicarageManager',
    ParishUnitManager = 'ParishUnitManager',
    ParishManager = 'ParishManager',
    Lay = 'Lay',
    Volunteer = 'Volunteer',
    General = 'General',
    Catechesis = 'Catechesis',
    Economy = 'Economy',
    Liturgy = 'Liturgy',
    Caritas = 'Caritas',
    AdolescenceYouth = 'AdolescenceYouth',
    AdultsFamily = 'AdultsFamily',
    Sacramental = 'Sacramental'
}

export class UserPermissions {
    public organizationId: number = 0;
    public roles: UserRoles[] = [];
    public entities: UserEntityPermissions[] = [];

    constructor(json?: any) {
        if (!json) {
            return;
        }

        Object.assign(
            this,
            json,
            { entities: json.entities ? json.entities.map((entity: any) => new UserEntityPermissions(entity)) : [] },
        );
    }
}
